module.exports = __webpack_public_path__ + "047ca6df551e63c41edebe190ac0b719.ttf";